/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;width:100%}.engine-scrubber[_ngcontent-%COMP%]{justify-content:center;align-items:center;display:flex;position:relative;width:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.engine-scrubber__input[_ngcontent-%COMP%]{width:100%}.engine-scrubber__play[_ngcontent-%COMP%]{width:80px}"];
export { styles as styles };
